import { inject } from "@angular/core"
import { HttpResponse, HttpInterceptorFn } from "@angular/common/http"
import { map } from 'rxjs/operators'
import { CONSTANTS } from '../../helper/constants'
import { ERRORCODES } from '../../helper/error-codes'
import { SharedDataService } from '../../helper/services/shared-data.service'

export const HttpResponseInterceptor: HttpInterceptorFn = (req, next) => {

  const sharedDataService = inject(SharedDataService);

  if (!CONSTANTS.httpInterceptorExceptions.includes(req.url)) {
    return next(req).pipe(map(data => {
      if (data instanceof HttpResponse) {
        sharedDataService.toggleProgressBarOff();

        if (data.body === ERRORCODES.RESPONSE_FORBIDDEN.error_code) {
          localStorage.removeItem('currentUser')
          sessionStorage.clear()
          window.location.href = '/login'
        }

        switch (data.body) {
          case ERRORCODES.RESPONSE_DATABASE_ERROR.error_code:
          case ERRORCODES.RESPONSE_FAILED_LOGIN.error_code:
          case ERRORCODES.RESPONSE_LIMIT_REACHED.error_code:
          case ERRORCODES.RESPONSE_MALFORMED_PAYLOAD.error_code:
          case ERRORCODES.RESPONSE_RESOURCE_EXPIRED.error_code:
          case ERRORCODES.RESPONSE_RESOURCE_READ_ONLY.error_code:
          case ERRORCODES.RESPONSE_PAYMENT_REQUIRED.error_code:
          case ERRORCODES.RESPONSE_NOT_EMPTY.error_code:
          case ERRORCODES.RESPONSE_PAYLOAD_SIZE_EXCEEDED.error_code:
          case ERRORCODES.RESPONSE_WRONG_API_KEY.error_code:
          case ERRORCODES.RESPONSE_MISSING_PASSWORD.error_code:
          case ERRORCODES.RESPONSE_NOT_AUTHORIZED.error_code:
          case ERRORCODES.RESPONSE_DUPLICATE_KEY.error_code:
          case ERRORCODES.RESPONSE_UNPROCESSABLE_ENTITY.error_code:
          case ERRORCODES.RESPONSE_FORBIDDEN.error_code:
          case ERRORCODES.RESPONSE_IN_USE.error_code:
            throw data;
          case ERRORCODES.RESPONSE_SUCCESS.error_code:
          default:
            break;
        }
      }
      return data;
    }));
  }

  return next(req);
};
